
export default {
  props: {
    team: {
      type: Object,
      required: true,
    },
    subsOnly: {
      type: Boolean,
      default: false,
    },
  },
  inject: [`lastUpdated`],
  computed: {
    lineup () {
      if (this.team.lineups) {
        // Return sorted Lineup
        const startingLineup = [...this.team.lineups]
          .filter(lineup => lineup.position !== `Substitute`)
          .sort((a, b) => parseInt(a.formationNumber) - parseInt(b.formationNumber));
        const subs = [...this.team.lineups]
          .filter(lineup => lineup.position === `Substitute`)
          .sort((a, b) => parseInt(a.formationNumber) - parseInt(b.formationNumber));

        return [...startingLineup, ...subs];
      }
      return false;
    },
    startingXi () {
      if (this.lineup && !this.subsOnly) {
        return this.lineup.filter(player => player.position !== `Substitute`);
      }
      return null;
    },
    subs () {
      if (this.lineup) {
        return this.lineup.filter(player => player.position === `Substitute`);
      }
      return null;
    },
    side () {
      return this.team.side;
    },
  },
};
